/**
 * Accepts a Date and convert it to utc timestamp
 */
export const dateToUtcTimestamp = date => {
    return Math.floor(Date.parse(date.toUTCString()) / 1000);
};
